import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import FreelanceJobService from '../api/FreelanceJobService';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

export const getFreelanceJobMethod = createAsyncThunk(`/freelanceJob/get-freelanceJob`, async () => {
  try {
    const { data } = await FreelanceJobService.get();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const freelanceJobSlice = createSlice({
  name: 'freelanceJob',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getFreelanceJobMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getFreelanceJobMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getFreelanceJobMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default freelanceJobSlice.reducer;
